<template>
    <div class="right-aside">
        <div class="right-aside-content">
            <div class="right-aside-zitems">
                <DataStatistics :dataList="dataList" @bindData="bindData" :currentIndex="statisticsData.listType">
                </DataStatistics>
            </div>
            <div class="aside-list">
                <template v-if="statisticsData.listType === 0">
                    <!-- 事件 -->
                    <template v-if="currentEventPageData && currentEventPageData.length > 0">
                        <YScroll style="height: 100%">
                            <el-popover v-for="(item, index) in currentEventPageData" :key="item.id + index"
                                popper-class="c-el-popover-blue main-task-tree-el-popover" effect="dark"
                                placement="right-start" trigger="hover">
                                <div slot="reference" class="item-desc display mar-bot-7"
                                    :class="activityId === item.id ? 'active' : 'empty'" @click="bindEvent(item)">
                                    <div class="item-img">
                                        <el-image class="img" :src="item.thumbnailUrl" fit="cover"></el-image>
                                    </div>
                                    <div class="item-main">
                                        <div class=" display mar-bot-7">
                                            <el-tooltip class="item" effect="dark" :content="item.name" placement="top"
                                                popper-class="txt-tooltip ">
                                                <div class="item-name">
                                                    {{ item.name }}
                                                </div>
                                            </el-tooltip>
                                            <div class="item-status" :class="{
                                                'is-unstart': item.status == 1,
                                                'is-starting': item.status == 2,
                                                'is-started': item.status == 3,
                                                'is-resulted': item.status == 4,
                                                'is-end': item.status == 5,
                                                'is-stop': item.status == 6,
                                            }">
                                                {{ item.statusLabel }}
                                            </div>
                                        </div>
                                        <div class="item-data display mar-bot-7">
                                            <div class="item-txt">
                                                {{ $t('chengguan.dailypatrol.discoveryTime') }}
                                            </div>
                                            <div class="item-val">{{ item.eventTime }}</div>
                                        </div>
                                        <div class="item-location display mar-bot-7">
                                            <div class="item-txt">
                                                {{ $t('chengguan.dailypatrol.location') }}
                                            </div>
                                            <div class="item-val">{{ item.location }}</div>
                                            <i class="iconfont icon-dingwei"
                                                style="margin-left:15px; font-size: 14px;"></i>
                                        </div>

                                    </div>
                                </div>
                                <template>
                                    <EventPop class="event-popup-content" :itemObj="item" :clickable="false"
                                        :border="false" :translate="(key) => $t(key)">
                                    </EventPop>
                                </template>
                            </el-popover>
                        </YScroll>
                    </template>
                    <template v-else>
                        <div class="aside-list-empty">{{ $t('chengguan.dailypatrol.noDataAvailable') }}</div>
                    </template>
                </template>
                <!-- 照片 -->
                <template v-else>
                    <template v-if="currentPhotoPageData && currentPhotoPageData.length > 0">
                        <YScroll style="height: 100%">
                            <div v-for="(photoItem, index) in currentPhotoPageData" :key="index"
                                class="item-desc display" :class="activityId === photoItem.id ? 'active' : 'empty'"
                                @click="bindTask(photoItem)">
                                <div class="item-img">
                                    <el-image class="img" :src="photoItem.thumbnailUrl" fit="cover"></el-image>
                                </div>
                                <div class="item-main">
                                    <div class="display">
                                        <div class="item-name  mar-bot-7" style="width: 83%">{{ photoItem.name }} </div>
                                        <i class="iconfont icon-dingwei item-icon" style="margin-top: 5px;"></i>
                                    </div>
                                    <div>{{ $t('hezhang.dailypatrol.shootingTime') }} {{ photoItem.shootingTime }}</div>
                                </div>
                            </div>
                        </YScroll>
                    </template>
                    <template v-else>
                        <div class="aside-list-empty">{{ $t('chengguan.dailypatrol.noDataAvailable') }}</div>
                    </template>
                </template>
            </div>
        </div>
        <div class="right-aside-bottom display" v-if="currentPhotoPageData.length > 1">
            <div class="bottom-content">
                <el-pagination class="pagination-mian" small background align="center" :total="pageData.total"
                    :pageSize.sync="pageData.pageSize" :currentPage.sync="pageData.currentPage"
                    layout="prev, pager, next" @current-change="getPhotoPage">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { YScroll } from '@CommonComponent';
import DatepickerMixin from '@/mixins/datepicker.js';

import DataStatistics from '../../components/DataStatistics.vue';
// import Pagination from '@/page/taskPage/common/Pagination.vue';
import EventPop from '@/page/mainPage/mapComponents/EventPop.vue';

export default {
    mixins: [DatepickerMixin],
    components: {
        DataStatistics,
        YScroll,
        // Pagination,
        EventPop,
    },
    props: {

        photoList: {
            type: Array,
            default () {
                return [];
            },
        },
        eventList: {
            type: Array,
            default () {
                return [];
            },
        },
        // 统计数据列表
        statisticsData: {
            type: Object,
            default () {
                return {};
            },
        },
    },
    data () {
        return {
            dataList: [],
            activityId: '',
            routeObj: {},
            searchForm: {
                pageNum: 1,
                pageSize: 10,
                totalResult: 0,
            },
            currentEventPageData: [],
            currentPhotoPageData: [],

            pageData: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
            },
        };
    },
    watch: {
        searchForm: {
            handler (newVal) {

            },
            immediate: true,
            deep: true,
        },
        photoList: {
            handler (newVal) {
                this.getCurrentPageData(newVal, 1); // 重新计算当前页数据
            },
            immediate: true,
            deep: true,
        },
        eventList: {
            handler (newVal) {
                this.getCurrentPageData(newVal, 0); // 重新计算当前页数据
            },
            immediate: true,
            deep: true,
        },
        statisticsData: {
            handler (newVal) {
                let list = [
                    {
                        id: 0,
                        url: 'icon-suspected',
                        name: this.$t('chengguan.dailypatrol.suspectedEventDiscovered'),
                        unit: this.$t('chengguan.dailypatrol.piece'),
                        value: 0,
                    },
                    {
                        id: 1,
                        url: 'icon-patrol',
                        name: this.$t('chengguan.dailypatrol.takePicturesNumber'),
                        unit: this.$t('chengguan.dailypatrol.fix'),
                        value: 0,
                    },
                ];
                if (newVal.list.length > 0) {
                    // 建立name到list索引的映射关系
                    const nameToIndexMap = {
                        event: 0, // event对应list[0]
                        picture: 1, // picture对应list[1]
                    };

                    // 遍历数据并赋值
                    newVal.list.forEach((item) => {
                        const targetIndex = nameToIndexMap[item.name];
                        // 如果存在对应关系，则赋值（自动忽略不需要的name）
                        if (targetIndex !== undefined) {
                            list[targetIndex].value = Number(item.value); // 如需数字可加 Number() 转换
                        }
                    });
                }

                this.dataList = list;
                this.pageData.total = newVal.listType === 0 ? list[0].value : list[1].value;
            },
            immediate: true,
            deep: true,
        },
    },
    computed: { },
    methods: {
        // 计算当前页数据
        getCurrentPageData (list, type) {
            this.currentPhotoPageData = [];
            const { currentPage, pageSize } = this.pageData;
            // 计算截取的起始索引和结束索引
            const startIndex = (currentPage - 1) * pageSize;
            const endIndex = startIndex + pageSize;

            // 截取原始数据，得到当前页数据
            let arr = list.slice(startIndex, endIndex);
            if (type === 0) {
                this.currentEventPageData = arr;
            } else {
                this.currentPhotoPageData = arr;
            }
        },

        getPhotoPage (page) {
            this.pageData.currentPage = page;
            let type = this.statisticsData.listType;
            let list = type === 0 ? this.eventList : this.photoList;
            this.getCurrentPageData(list, type); // 重新计算当前页数据
        },
        // 点击事件详情
        bindEvent (item) {
            this.activityId = item.id;
            this.$emit('bindPosition', item);
        },

        // 点击任务详情
        bindTask (item) {
            this.$emit('bindPosition', item);
        },
        // 发现事件和巡查任务切换事件
        bindData (val) {
            this.$emit('bindType', val.id);
        },
    },
    created () { },
    mounted () {
    },
};
</script>
<style lang="scss" scoped>
.right-aside {
    padding: 10px;

    .right-aside-header {
        padding: 8px 0;

        .aside-search {
            .aside-search-label {
                width: 90px;
                line-height: 30px;
            }

            .aside-daterange {

                // background: hsl(238deg, 91%, 13%);
                // border: 1px solid #1947a3;
                .el-range-input {
                    // background: hsl(238deg, 91%, 13%);
                }
            }
        }
    }

    .right-aside-content {
        padding: 8px 0;

        .aside-list {
            height: 69vh;
            margin-top: 16px;
            position: relative;

            .item-desc {
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #1a47a4;
                margin-bottom: 12px;
                padding: 5px 0 5px 10px;

                &:hover {
                    background: rgba(30, 118, 237, 0.7);
                }

                .item-num {
                    width: 10px;
                    margin-right: 5px;
                    text-align: center;
                }

                .item-img {
                    margin: 5px 5px 5px 0;
                    width: 80px;
                    height: 60px;

                    .img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .item-main {
                    width: 75%;

                    .item-name {
                        width: 138px;
                        margin-right: 10px;
                        line-height: 22px;
                        font-size: 14px;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 隐藏超出的内容 */
                        text-overflow: ellipsis;
                        /* 用省略号表示被隐藏的部分 */
                    }

                    .item-status {
                        padding: 4px;
                        font-size: 12px;
                        max-width: 80px;
                    }

                    .item-txt {
                        max-width: 80px;
                        margin-right: 8px;
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.6);
                    }

                    .item-val {
                        color: rgba(255, 255, 255, 0.6);
                        font-size: 12px;
                        width: 120px;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 隐藏超出的内容 */
                        text-overflow: ellipsis;
                        /* 用省略号表示被隐藏的部分 */
                    }
                }
            }
        }

        .aside-list-empty {
            width: 100%;
            height: 650px;
            line-height: 650px;
            text-align: center;
        }
    }

    .right-aside-bottom {
        position: absolute;
        bottom: 15px;
        left: 15px;
        right: 10px;
        height: 30px;
        background: linear-gradient(180deg, rgba(7, 17, 80, 0) 0%, #071150 100%);

        .bottom-total {
            text-align: center;
            line-height: 25px;

            .total-num {
                width: 20px;
            }
        }

        .pagination-mian {
            color: #fff;

            ::v-deep .el-pagination__jump {
                color: #fff;
            }
        }
    }
}

.display {
    display: flex;
}

.mar-bot-7 {
    margin-bottom: 7px;
}

.main-task-tree-el-popover {
    background: #071150 !important;
}

.active {
    background: rgba(30, 118, 237, 0.7);
}

.empty {
    background: #112d7b;
}
</style>

<style lang="scss">
.bottom-content {
    margin: 0 auto;

    .el-input__inner {
        background-color: #112d7b !important;
        border: 1px solid #1a47a4 !important;
        box-sizing: border-box;
        color: #ffffff;
        display: inline-block;
        font-size: inherit;
        height: 30px;
        line-height: 30px;
        outline: 0;
        padding: 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
        margin: 0 5px;
        background-color: #112d7b;
        border-radius: 2px;
        color: #fff;
    }

    .btn-next {
        /*对下一页的按钮样式进行修改*/
        background-color: #112d7b;
        color: #fff;
    }

    .btn-prev {
        /*对上一页的按钮样式进行修改*/
        background-color: #112d7b;
        color: #fff;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: rgba(73, 240, 253, 0.2) !important;
    }
}
</style>
